export var StickyNoteColors;
(function (StickyNoteColors) {
    StickyNoteColors["YELLOW"] = "#fff68b";
    StickyNoteColors["PINK"] = "#ff7ecd";
    StickyNoteColors["BLUE"] = "#71d7ff";
    StickyNoteColors["PURPLE"] = "#ce81ff";
    StickyNoteColors["GREEN"] = "#cdfc93";
})(StickyNoteColors || (StickyNoteColors = {}));
